import React from 'react'
import styled from 'styled-components'
import WP_DATA from 'utils/wp_data'
import mixins from 'utils/mixins'

const Background = styled.div`
  ${mixins.lightBackground}
`

const triggerReportDownload = () => {
  typeof document !== 'undefined' && (
    document.getElementById('report')?.click()
  )
}

export default () => (
  <Background>
    <h2>Thank you for completing.</h2>
    <p style={{fontSize: 24}}>Please <a href="#" onClick={triggerReportDownload}>download your report</a> for your records. Please <a href={`${WP_DATA.site_url}/${WP_DATA.PLUGIN_SLUG}`}>return to the dashboard</a> and make sure to complete all worksheets.</p>
  </Background>
)